import { Alert, Button, Group, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconBell, IconBellOff, IconInfoCircle } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { sporocilo } from '../api/napaka';
import { izklopiPush, stanjePush, vklopiPush, type StanjePush } from './push';

/**
 * Push obvestila o novih povpraševanjih v tem brskalniku: en gumb za vklop/izklop, pri iPhonu navodilo za dodajanje
 * na začetni zaslon, pri zavrnjenem dovoljenju navodilo za brskalnik.
 */
export function VklopObvestil() {
  const [stanje, setStanje] = useState<StanjePush | null>(null);
  const [dela, setDela] = useState(false);
  useEffect(() => {
    void stanjePush().then(setStanje);
  }, []);

  const preklopi = async () => {
    setDela(true);
    try {
      if (stanje === 'vklopljeno') {
        await izklopiPush();
        notifications.show({ message: 'Obvestila v tem brskalniku so izklopljena.' });
      } else {
        await vklopiPush();
        notifications.show({
          color: 'green',
          message: 'Obvestila so vklopljena. Ob novem povpraševanju vas obvestimo.',
        });
      }
    } catch (e) {
      notifications.show({ color: 'red', message: e instanceof Error && !('koda' in e) ? e.message : sporocilo(e) });
    } finally {
      setDela(false);
      setStanje(await stanjePush());
    }
  };

  if (stanje === null || stanje === 'ni-podprto') {
    return null;
  }
  if (stanje === 'ios-namesti') {
    return (
      <Alert variant="light" icon={<IconInfoCircle size={18} />} title="Obvestila na iPhonu">
        <Text size="sm">
          Za obvestila o povpraševanjih najprej dodajte aplikacijo na začetni zaslon: v Safariju »Deli« → »Dodaj na
          začetni zaslon«, nato jo odprite z ikone in vklopite obvestila tukaj.
        </Text>
      </Alert>
    );
  }
  if (stanje === 'zavrnjeno') {
    return (
      <Alert variant="light" color="yellow" icon={<IconBellOff size={18} />} title="Obvestila so blokirana">
        <Text size="sm">
          Brskalnik obvestil za to stran ne dovoli. Dovolite jih v nastavitvah strani (ključavnica levo od naslova),
          nato osvežite stran.
        </Text>
      </Alert>
    );
  }
  return (
    <Group gap="xs">
      <Button
        variant={stanje === 'vklopljeno' ? 'default' : 'filled'}
        leftSection={stanje === 'vklopljeno' ? <IconBellOff size={18} /> : <IconBell size={18} />}
        onClick={() => void preklopi()}
        loading={dela}
      >
        {stanje === 'vklopljeno' ? 'Izklopi obvestila' : 'Vklopi obvestila'}
      </Button>
    </Group>
  );
}
